import React from 'react'
import { Link } from 'gatsby'
import Helmet from 'react-helmet'
import Layout from '../components/layout'
import Banner from '../components/Banner'



import pic01 from '../assets/images/banner.gif'
import pic13 from '../assets/images/pic/blue.jpeg'
import pic05 from '../assets/images/pic/pic05.jpeg'
import pic02 from '../assets/images/pic02.jpg'
import pic03 from '../assets/images/pic03.jpg'
import pic04 from '../assets/images/pic04.jpg'

import pic06 from '../assets/images/pic06.jpg'
import pic07 from '../assets/images/pic07.jpg'
import pic08 from '../assets/images/pic08.jpg'
import pic09 from '../assets/images/pic09.jpg'
import pic10 from '../assets/images/pic10.jpg'

import pic11 from '../assets/images/pic/pic11.jpeg'
import pic12 from '../assets/images/pic/pic12.jpeg'
import pic81 from '../assets/images/pic/pic81.jpg'

class HomeIndex extends React.Component {
    render() {

        return (
            <Layout>
                <Helmet
                    title="Tourism"
                    meta={[
                        { name: 'tour', content: 'World' },
                        { name: 'keywords', content: 'sample, something' },
                    ]}
                >
                </Helmet>

                <Banner />

                <div id="main">
                    <section id="one" className="tiles">



<article style={{backgroundImage: `url(${pic13})`}}>
                       
                            <header className="major">
                                <h3>Blue Lagoon</h3>
                                <p>Mystery</p>
                            </header>
                            <Link to="/landing" className="link primary"></Link>
                        </article>








                        <article style={{backgroundImage: `url(${pic01})`}}>
                            <header className="major">
                                <h3>Victoria Falls</h3>
                                <p>Magical</p>
                            </header>
                            <Link to="/landing" className="link primary"></Link>
                        </article>


                        <article style={{backgroundImage: `url(${pic05})`}}>
                       
                            <header className="major">
                                <h3>Chameleon</h3>
                                <p>Animal Kingdom</p>
                            </header>
                            <Link to="/generic" className="link primary"></Link>
                        </article>



                        <article style={{backgroundImage: `url(${pic81})`}}>
                            <header className="major">
                                <h3>Coral Reef</h3>
                                <p>Majestical</p>
                            </header>
                            <Link to="/landing" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${pic03})`}}>
                            <header className="major">
                                <h3> Lake Victoria</h3>
                                <p>Wonders</p>
                            </header>
                            <Link to="/landing" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${pic04})`}}>
                            <header className="major">
                                <h3>Cliffs of Moher</h3>
                                <p>Mystical</p>
                            </header>
                            <Link to="/landing" className="link primary"></Link>
                        </article>
                        
                        <article style={{backgroundImage: `url(${pic06})`}}>
                            <header className="major">
                                <h3>Sahara Eye</h3>
                                <p>Mystery</p>
                            </header>
                            <Link to="/landing" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${pic07})`}}>
                            <header className="major">
                                <h3>Sahara Desert</h3>
                                <p>Indomitable</p>
                            </header>
                            <Link to="/landing" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${pic08})`}}>
                            <header className="major">
                                <h3>Mount. Everest</h3>
                                <p>Highest</p>
                            </header>
                            <Link to="/landing" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${pic09})`}}>
                            <header className="major">
                                <h3>Grand Canyon</h3>
                                <p>Deepest</p>
                            </header>
                            <Link to="/landing" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${pic10})`}}>
                            <header className="major">
                                <h3>Great Wall of China</h3>
                                <p>Mighty Fortress</p>
                            </header>
                            <Link to="/landing" className="link primary"></Link>
                        </article>


                        <article style={{backgroundImage: `url(${pic11})`}}>
                            <header className="major">
                                <h3>Kangaroo</h3>
                                <p>Animal Kingdom</p>
                            </header>
                            <Link to="/generic" className="link primary"></Link>
                        </article>

                        <article style={{backgroundImage: `url(${pic12})`}}>
                            <header className="major">
                                <h3>Maned Wolf</h3>
                                <p>Animal Kingdom</p>
                            </header>
                            <Link to="/generic" className="link primary"></Link>
                        </article>
                    </section>
                    <section id="two">
                        <div className="inner">
                            <header className="major">
                                <h2>More Natural Beauty</h2>
                            </header>
                            <p>"I just wish the world was twice as big and half of it was still unexplored. <br />
People must feel that the natural world is important and valuable and beautiful and wonderful and an amazement and a pleasure."<br />
              <strong> Sir David Frederick Attenborough - Natural historian </strong> </p>
                            <ul className="actions">
                                <li><Link to="/landing" className="button next">Get Started</Link></li>
                            </ul>
                        </div>
                    </section>
                </div>

            </Layout>
        )
    }
}

export default HomeIndex